module.exports = __webpack_public_path__ + "img/statusPagePasswordLogo.2bfa79d6.svg";